import { render } from "./SecurityCamModule.vue?vue&type=template&id=83315118&scoped=true"
import script from "./SecurityCamModule.vue?vue&type=script&lang=js"
export * from "./SecurityCamModule.vue?vue&type=script&lang=js"

import "./SecurityCamModule.vue?vue&type=style&index=0&id=83315118&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-83315118"

export default script